import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { JsonApiWrap } from '../../shared/models/JsonApiWrap';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { AccountInfoApiResponse } from '../models/AccountInfoApiResponse';
import { ComponentState } from '../../shared/types/ComponentState';
import { IntegrationService } from '../../shared/services/integration.service';
import { PALHeaderResponse } from '../models/PALHeaderResponse';

@Injectable({
  providedIn: 'root',
})
export class AccountInfoHeaderService {
  statusViewExperiencePath: string = 'api/ria.MoneyMovementStatusviewExperience';
  componentState: ComponentState;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private http: HttpClient,
    private integrationService: IntegrationService,
    private headersService: HeadersService,
  ) {}

  getAccountInfo(accountId: string): Observable<AccountInfoApiResponse> {
    const header = this.getHeadersWithClientIds(`1=${accountId}`);
    const headers = new HttpHeaders(header);
    const url = `${this.integrationService.JfkEnv.BaseUrl}${this.statusViewExperiencePath}/v1/AccountInfo?${encodeURIComponent('filter[subaccount]')}=${encodeURIComponent('$1')}`;
    return this.http.get<JsonApiWrap<AccountInfoApiResponse>>(url, { headers }).pipe(map(res => res.data.attributes))
  }

  getAccountInfoForPal(accountId: string): Observable<PALHeaderResponse> {
    const header = this.getHeadersWithClientIdsForPal(`1=${accountId}`);
    const headers = new HttpHeaders(header);
    const url = `${this.integrationService.JfkEnv.BaseUrl}${this.statusViewExperiencePath}/v1/AccountInfo?${encodeURIComponent('filter[subaccount]')}=${encodeURIComponent('$1')}`;
    return this.http.get<JsonApiWrap<PALHeaderResponse>>(url, { headers }).pipe(map(res => res.data.attributes))
  }

  public getHeadersWithClientIds(clientIds: string): {
    [name: string]: string;
  } {
    // TODO: update environment with env variable once set up
    var headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    headers['Cache-Control'] = 'no-cache';
    headers['Schwab-Client-Ids'] = clientIds;
    headers['Is-Create-Sloa'] = 'true';
    headers['Is-Bundled-Sloa'] = 'true';
    return headers;
  }
  
  public getHeadersWithClientIdsForPal(clientIds: string): {
    [name: string]: string;
  } {
    let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    headers['Cache-Control'] = 'no-cache';
    headers['Schwab-Client-Ids'] = clientIds;
    headers['Is-Create-Sloa'] = 'true';
    headers['Is-Bundled-Sloa'] = 'true';
    headers['Account-Type'] = 'PALACCOUNT';
    headers['sac-cxt'] = 'yAABngAkAMkA0wBVAAAdAAg%3d';
    return headers;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
